
import {defineComponent} from "vue";
import {DocumentRestService} from "@/services/rest/master/DocumentRestService";
import {DpModuleEnum} from "@/api/enums/dp-module-enum";

export default defineComponent({
  name: "LazyImage",
  props: {
    imageKey: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: false,
      default: 'Image'
    }
  },
  data: () => ({
    imageUrl: ''
  }),
  mounted() {
    this.reloadContent();
  },
  methods: {
    async reloadContent(): Promise<void> {
      this.imageUrl = await DocumentRestService.getInstance().findPublicPreviewUrl(this.imageKey, DpModuleEnum.CMS);
    }
  }
});
